import { render, staticRenderFns } from "./SeguimentoRead.vue?vue&type=template&id=01853305&"
import script from "./SeguimentoRead.vue?vue&type=script&lang=js&"
export * from "./SeguimentoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports